import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from '@cbridge-utils/react-redux';
import { NavigationItemContextMenu } from '@cbridge-tools/navigation-block';
import { useDialogs } from '@cbridge-modules/dialog';
import { MarkupProfileAction } from '@cbridge-packages/markup-profile';
import { MarkupProfileFormDialog } from '../_dialogs/MarkupProfileFormDialog';
import { IMarkupProfileContextMenuProps } from './MarkupProfileContextMenu.interface';

export const MarkupProfileContextMenu: FunctionComponent<IMarkupProfileContextMenuProps> = ({ item }) => {
  const {
    value,
    label: markupProfileName,
  } = item;
  const profileId = value as number;

  const { t } = useTranslation();

  const dialogs = useDialogs();

  const dispatch = useDispatch();

  const handleDelete = async () => {
    const isProceed = await dialogs.confirmDelete(
      t('text:configPage.markups.dialog.delete.description', '', { markupProfileName }),
      {
        title: t('text:configPage.markups.dialog.delete.title'),
      },
    );
    if (isProceed) {
      dispatch(MarkupProfileAction.remove.started({ profileId }));
    }
  };

  const handleEdit = async () => {
    const success = await dialogs.open(MarkupProfileFormDialog, { markupProfileId: profileId, markupProfileName });

    if (success) {
      dispatch(MarkupProfileAction.loadList.started());
    }
  };

  return (
    <NavigationItemContextMenu
      onEdit={handleEdit}
      onDelete={handleDelete}
    />
  );
};
